




import Vue from 'vue';
import ImportantInformationSendHistoryList from '@/components/important-information/important-information-send-history-list.component.vue';

export default Vue.extend({
  components: {
    'important-information-send-history-list': ImportantInformationSendHistoryList,
  },
});
